<script>
import ViewTitle from '@/components/ViewTitle'
import CreateAccount from '@/components/CreateAccount'
import AlertBubble from '@/components/AlertBubble'
import EnvironmentUtils from '@/utils/environmentUtils'
import DeviceUtils from '@/utils/deviceUtils'
import AccountServices from '@/services/accounts'

export default
{
    name: 'loayalty-card-create-account',

    render () 
    {
        return (
            <div id='loyalty-card-create-account-view'>
                <div id='title'>Créer ma carte 💳</div>
                <div id='subtitle'>Vous y êtes presque, tous vos commerces de Gouvieux sont à portée de main !</div>
                <create-account title='' success-btn-text='voir ma carte' success-btn-action={() => this.$router.push({name: 'LoyaltyCardOverview'})}
                    on-account-created={this.onAccountCreated} />
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    methods:
    {
        async onAccountCreated (accountDetails)
        {
            const cityId = EnvironmentUtils.cityId

            console.log('Accont', accountDetails, 'created, logging in')

            const {token} = await AccountServices.login(accountDetails.username, accountDetails.password, cityId, DeviceUtils.deviceInfo)
            await this.$store.dispatch('user/fetchUserInformationFromToken', { token, cityId })
        },
    },

    components:
    {
        ViewTitle,
        CreateAccount,
        AlertBubble
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#loyalty-card-create-account-view
{
    display: flex;
    align-items: center;
    margin-top: 12vw;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);
    flex-direction: column;
    padding: 2.5vw;
    font-size: 13px;

    #title
    {
        font-family: 'Inter';
        font-size: 36px;
        font-weight: bold;
        margin-bottom: 2vh;
    }

    #subtitle
    {
        margin: 0 29px;
        font-size: 14px;
    }

    .create-account
    {
        width: -webkit-fill-available;

        .create-account-form
        {
            background-color: transparent;
            box-shadow: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/LoyaltyCardCreateAccount.vue